'use client';

import React, { useState } from 'react';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { CheckCircle, Calendar, Clock, Video } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const CALENDLY_URL = 'https://calendly.com/rakib-cma/30min';

export default function BookingWidget() {
  const [booked, setBooked] = useState(false);

  useCalendlyEventListener({
    onEventScheduled: () => setBooked(true),
  });

  return (
    <div className="w-full">
      {booked && (
        <div className="mb-6 flex items-center gap-3 bg-green-50 border border-green-200 rounded-xl px-5 py-4">
          <CheckCircle className="text-green-500 shrink-0" size={22} />
          <div>
            <p className="font-semibold text-green-800 text-sm">Session booked successfully!</p>
            <p className="text-green-700 text-xs mt-0.5">Check your email for confirmation and Zoom link details.</p>
          </div>
        </div>
      )}

      {/* Info cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        {[
          { icon: Clock, label: '30 Minutes', sub: 'Session duration' },
          { icon: Video, label: 'Zoom Meeting', sub: 'Video call' },
          { icon: Calendar, label: 'Flexible Timing', sub: 'Pick your slot' },
        ]?.map(({ icon: Icon, label, sub }) => (
          <div key={label} className="flex items-center gap-3 bg-card border border-border rounded-xl px-4 py-3.5">
            <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
              <Icon size={18} className="text-primary" />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground">{label}</p>
              <p className="text-xs text-muted-foreground">{sub}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Calendly inline widget */}
      <div className="rounded-2xl overflow-hidden border border-border shadow-sm bg-card">
        <InlineWidget
          url={CALENDLY_URL}
          styles={{ height: '700px', minWidth: '320px' }}
          pageSettings={{
            backgroundColor: 'ffffff',
            hideEventTypeDetails: false,
            hideLandingPageDetails: false,
            primaryColor: '8247f5',
            textColor: '1a1a2e',
          }}
        />
      </div>
    </div>
  );
}
